import { Action } from '@/_core/fluxstore/types';
import { NotificationsState } from '../types';
import { useNotificationsStore } from '../useModule';

const { registerReducer } = useNotificationsStore();

export class HideDismissedNotifications extends Action<NotificationsState> {
    public static ACTION_TYPE = 'HideDismissedNotifications';
    public constructor() {
        super(HideDismissedNotifications.ACTION_TYPE);
    }
}

// eslint-disable-next-line
const reducer = (state: NotificationsState, action: HideDismissedNotifications): void => {
    state.isDismissedNotificationsVisible = false;
};

//@ts-ignore
registerReducer(HideDismissedNotifications.ACTION_TYPE, reducer);
